import type { Pay } from './Pay';

export const base: Pay = {
    csto: {
        enabled: false,
        _description: 'Enables Contractual standing orders feature',
    },
    ABService: {
        enabled: false,
        _description: 'Enables to use Address book Payment Service',
    },
    isoSto: {
        enabled: false,
        _description: 'Enables ISO address configuration for standing orders',
    },
};
